import * as styledComponents from 'styled-components';
var _a = styledComponents, styled = _a.default, css = _a.css, createGlobalStyle = _a.createGlobalStyle, keyframes = _a.keyframes, ThemeProvider = _a.ThemeProvider;
var remCalc = function (px) { return 0.0625 * px + "rem"; };
export { styled, css, createGlobalStyle, keyframes, remCalc, ThemeProvider };
export default styled;
